import React, { useState, useEffect } from 'react';

const CardPerfilCliente = ({
    nombre = 'DESOFIW FACTURACION',
    rtn = 'Empresa de desarrollo de software.',
    avatarUrl = 'https://images.unsplash.com/photo-1502685104226-ee32379fefbe?q=80&w=600', // reemplaza con tu imagen
    empresa = [],
    seleccionarRtn
}) => {
    const [selectedEmpresa, setSelectedEmpresa] = useState('');
    useEffect(() => {
        seleccionarRtn(selectedEmpresa)
        if (empresa.length > 0) {
            setSelectedEmpresa(empresa[0].rtn);
            seleccionarRtn(empresa[0].rtn)
        }
        else {
            setSelectedEmpresa(rtn);
            seleccionarRtn(rtn)
        }
    }, [empresa]);

    return (
        <div className="card card-widget widget-user shadow">
            {/* Header con fondo teal */}
            <div className="widget-user-header bg-info">
                <h3 className="widget-user-username text-uppercase">{nombre}</h3>
                <h5 className="widget-user-desc">{rtn}</h5>
            </div>

            {/* Imagen circular */}
            <div className="widget-user-image">
                <img
                    className="img-circle elevation-2"
                    src={avatarUrl}
                    alt="Imagen"
                    style={{ width: '90px', height: '90px', objectFit: 'cover' }}
                />
            </div>

            {/* Body opcional */}
            <div className="card-footer">
                <div className="row">
                    <div className="col-sm-12 text-center">
                        {empresa.length > 0 ? (
                            <div className="form-group">
                                <div className="d-flex flex-column flex-md-row flex-wrap justify-content-center align-items-start gap-2">
                                    {empresa.map((item, index) => (
                                        <div className="form-check" key={index}>
                                            <input
                                                className="form-check-input"
                                                type="radio"
                                                name="empresa"
                                                id={`empresa-${index}`}
                                                value={item.rtn}
                                                checked={selectedEmpresa === item.rtn}
                                                onChange={() => setSelectedEmpresa(item.rtn)}
                                            />
                                            <label
                                                className="form-check-label text-muted"
                                                htmlFor={`empresa-${index}`}
                                                style={{
                                                    wordBreak: 'break-word',
                                                    maxWidth: '240px',
                                                    fontSize: '0.9rem',
                                                }}
                                            >
                                                <strong>{item.rtn}</strong><br />
                                                {item.nombre}
                                            </label>
                                        </div>
                                    ))}
                                </div>
                            </div>
                        ) : (
                            <span className="text-muted">No hay rtn de empresas disponibles</span>
                        )}
                    </div>
                </div>
            </div>

        </div>

    );
};

export default CardPerfilCliente;